import React from 'react'
import tw, { styled, css } from 'twin.macro'

export const StartRecording = () => {
  return (
    <GrowOnHoverSVG
      duration={150}
      scale={1.2}
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      fill="none"
    >
      <circle
        cx="50"
        cy="50"
        r="49.102"
        fill="#AC0AE8"
        stroke="#AC0AE8"
        strokeWidth="1.796"
      ></circle>
      <circle
        cx="50"
        cy="50"
        r="47.5"
        fill="url(#paint0_linear)"
        opacity="0.21"
      ></circle>
      <g opacity="0.1">
        <circle
          cx="50"
          cy="50"
          r="47.5"
          fill="url(#paint1_linear)"
          opacity="0.21"
        ></circle>
      </g>
      <path
        fill="#fff"
        d="M78.832 54.848v-14.94c0-.098-.002-.197-.007-.295l-.01-.138c-.004-.05-.007-.102-.013-.153-.006-.059-.014-.117-.021-.175l-.015-.113a5.668 5.668 0 00-.033-.188c-.006-.033-.011-.066-.018-.098a6.198 6.198 0 00-.043-.19l-.022-.095a6.206 6.206 0 00-.051-.182l-.03-.101c-.017-.056-.036-.11-.056-.167-.013-.038-.025-.076-.04-.114-.018-.05-.037-.1-.057-.149-.017-.043-.034-.086-.053-.128a6.55 6.55 0 00-.057-.129l-.067-.143-.055-.108a6.132 6.132 0 00-.083-.157l-.053-.092a6.919 6.919 0 00-.097-.163l-.053-.083a5.814 5.814 0 00-.108-.163l-.059-.082a5.6 5.6 0 00-.114-.155l-.072-.09c-.037-.046-.074-.093-.112-.138-.034-.04-.069-.078-.103-.116l-.094-.105a6.354 6.354 0 00-.431-.418c-.036-.031-.073-.06-.108-.091l-.12-.1a4.91 4.91 0 00-.144-.108l-.091-.07a5.084 5.084 0 00-.16-.11l-.084-.057a6.062 6.062 0 00-.168-.105l-.086-.052-.168-.094-.096-.051c-.053-.028-.107-.054-.16-.08l-.112-.054a6.04 6.04 0 00-.148-.065l-.132-.055-.133-.051a5.743 5.743 0 00-.153-.056l-.118-.039a5.48 5.48 0 00-.172-.053l-.105-.03a6.58 6.58 0 00-.188-.048l-.098-.023a5.71 5.71 0 00-.196-.041l-.101-.018a7.628 7.628 0 00-.194-.031l-.117-.015c-.06-.007-.12-.015-.18-.02-.053-.006-.106-.009-.159-.012-.047-.004-.094-.008-.141-.01a6.342 6.342 0 00-.61 0 3.27 3.27 0 00-.142.01c-.053.003-.106.006-.16.011l-.18.021-.116.015c-.065.009-.13.02-.194.031l-.102.018c-.065.012-.13.027-.195.041l-.098.023a6.634 6.634 0 00-.188.049c-.035.01-.07.018-.105.029-.058.016-.114.035-.172.053l-.118.039-.153.056-.133.05-.132.056-.148.065-.112.054a5.508 5.508 0 00-.161.08c-.032.016-.064.034-.095.051-.057.03-.113.062-.169.094l-.085.052a4.324 4.324 0 00-.17.105l-.082.056a6.552 6.552 0 00-.162.11l-.091.07a2.913 2.913 0 00-.145.11c-.04.032-.078.066-.118.099a6.117 6.117 0 00-.327.291l-.004.004-14.142 13.701v-25.91a5.844 5.844 0 00-1.04-3.32 6.13 6.13 0 00-2.768-2.2 6.354 6.354 0 00-3.563-.34c-1.197.23-2.296.8-3.158 1.635L25.13 37.177a5.947 5.947 0 00-1.341 1.94 5.796 5.796 0 00-.469 2.291v5.97L11.25 59.073a6.184 6.184 0 002.001 1.295 6.34 6.34 0 004.72 0c.749-.3 1.429-.74 2.002-1.295l15.684-15.195v25.909c0 1.182.362 2.337 1.04 3.32a6.13 6.13 0 002.767 2.2 6.352 6.352 0 003.564.34 6.232 6.232 0 003.158-1.635l14.142-13.701v12.463c0 1.585.65 3.105 1.807 4.226a6.27 6.27 0 004.361 1.75L85 60.823a6.27 6.27 0 01-4.361-1.75 5.882 5.882 0 01-1.807-4.225z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="97.5"
          x2="2.5"
          y1="2.5"
          y2="97.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0"></stop>
          <stop offset="0.464" stopColor="#fff"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="97.5"
          x2="2.5"
          y1="2.5"
          y2="97.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0"></stop>
          <stop offset="0.464" stopColor="#fff"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
      </defs>
    </GrowOnHoverSVG>
  )
}

export const GrowOnHoverSVG = styled.svg(
  {
    cursor: 'pointer'
  },
  ({ duration = 100, scale = 1.05 }) => [
    tw`transition-transform transform`,
    css`
      filter: drop-shadow(0px 15px 30px rgba(0, 0, 0, 0.12));
      transition-duration: ${duration}ms;
      &:hover {
        transform: scale(${scale});
      }
    `
  ]
)
